"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.basketProviderActions = exports.initialState = exports.INITIAL_SYSTEM_SIZE = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const difference_1 = __importDefault(require("../../utils/functions/difference"));
const cloneDeep_1 = __importDefault(require("../../utils/functions/cloneDeep"));
const mapValues_1 = __importDefault(require("../../utils/functions/mapValues"));
const uniq_1 = __importDefault(require("../../utils/functions/uniq"));
const map_1 = __importDefault(require("../../utils/functions/map"));
const get_1 = __importDefault(require("../../utils/functions/get"));
const set_1 = __importDefault(require("../../utils/functions/set"));
const api_1 = require("../../utils/api");
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const _reduxjs_1 = require("../../utils/@reduxjs");
const utils_1 = require("./utils");
const types_1 = require("./types");
const state_1 = require("./utils/state");
const REDUCER_KEY = 'basketProvider';
exports.INITIAL_SYSTEM_SIZE = 2;
exports.initialState = {
    layout: {
        headerTab: types_1.EBasketHeaderTypes.Coupon,
        betTypeTab: types_1.EBetTypes.Ordinar,
        bonusWallet: false,
        isShowMakeBasketSuccessMessage: false,
        coefficientStatusOnChanged: betweb_openapi_axios_1.BetSaveAny.Always,
        mobileModalType: types_1.EMobileModalType.OFF,
        highlightedDependentOutcomesList: [],
    },
    ordinar: {
        singleAmount: '',
        outcomesAmounts: {},
        singleAmountActive: false,
        outcomeErrors: {},
        errorMessages: {},
    },
    express: {
        amount: '',
    },
    system: {
        amount: '',
        size: exports.INITIAL_SYSTEM_SIZE,
    },
    basket: {
        entry: {
            outcomesMap: {
                entries: {},
                sortedIds: [],
            },
            dependentEventGroups: [],
        },
        constraints: {},
        fetchItem: api_1.requestInitialState,
        appliedCouponIds: [],
        currentAppliedCoupon: null,
    },
    addToBasketRequest: api_1.requestInitialState,
    deleteBasketRequest: api_1.requestInitialState,
    deleteBasketOutcomeRequest: api_1.requestInitialState,
    getBasketsRequest: api_1.requestInitialState,
    makeBetRequest: api_1.requestInitialState,
    errors: [],
    clientErrors: [],
    competitorConstraints: {
        rejectedEventIds: [],
    },
    loadingOutcomeKeys: {},
};
const basketStateSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        handleTabChange(state, { payload }) {
            state.layout.headerTab = payload.headerTab;
        },
        toggleMobileModal(state, { payload }) {
            state.layout.mobileModalType = payload.modalType;
        },
        setCoefficientStatusOnChanged(state, { payload }) {
            state.layout.coefficientStatusOnChanged = payload.status;
        },
        handleBetTypeTabChange(state, { payload }) {
            if (!state.makeBetRequest.loading) {
                state.layout.betTypeTab = payload.betTypeTab;
            }
        },
        handleBetTypeTabChangeMobile(state, { payload }) {
            if (!state.makeBetRequest.loading) {
                state.layout.betTypeTab = payload.betTypeTab;
                state.errors = [];
                state.clientErrors = [];
            }
        },
        // we check some errors for "web-mobile" EXPRESS_LENGTH and SYSTEM_LENGTH on change in the number of outcomes
        triggerBasketOutcomesLength(_) { },
        setSingleAmountForEachOutcome(state, { payload: { amount }, }) {
            state.ordinar.singleAmount = amount;
            const basketOutcomesMapByNativeId = (0, utils_1.basketOutcomesMapToId)(state.basket.entry.outcomesMap.entries);
            state.ordinar.outcomesAmounts = (0, mapValues_1.default)(basketOutcomesMapByNativeId, () => amount);
            state.ordinar.outcomeErrors = (0, mapValues_1.default)(basketOutcomesMapByNativeId, ({ id, maxBet }) => ({ id, amount, maxBet }));
        },
        setSingleAmountActive(state, action) {
            state.ordinar.singleAmountActive = action.payload;
        },
        resetSingleAmount(state) {
            state.ordinar.singleAmount = exports.initialState.ordinar.singleAmount;
            state.ordinar.singleAmountActive = exports.initialState.ordinar.singleAmountActive;
        },
        resetOutcomesAmounts(state) {
            state.ordinar.outcomesAmounts = exports.initialState.ordinar.outcomesAmounts;
        },
        resetOrdinarErrors(state) {
            state.ordinar.outcomeErrors = exports.initialState.ordinar.outcomeErrors;
            state.ordinar.errorMessages = exports.initialState.ordinar.errorMessages;
        },
        setOrdinarAmount(state, { payload: { outcomeId, amount, maxBet }, }) {
            state.ordinar.outcomesAmounts[outcomeId] = amount;
            state.ordinar.outcomeErrors[outcomeId] = {
                id: outcomeId,
                amount,
                maxBet,
            };
        },
        setExpressAmount(state, { payload: { amount } }) {
            state.express.amount = amount;
        },
        setSystemAmount(state, { payload: { amount } }) {
            state.system.amount = amount;
        },
        setSystemSize(state, { payload }) {
            state.system.size = payload;
        },
        makeBet(state) {
            state.errors = [];
            state.clientErrors = [];
            state.makeBetRequest.loading = true;
            state.makeBetRequest.error = null;
        },
        makeBetSuccess(state) {
            state.makeBetRequest.loading = false;
            state.makeBetRequest.error = null;
        },
        makeBetError(state, action) {
            state.makeBetRequest.loading = false;
            state.makeBetRequest.error = action.payload;
            const { details } = action.payload;
            if ((details === null || details === void 0 ? void 0 : details.schema) === 'BetCompetitorConstraintError') {
                state.competitorConstraints.rejectedEventIds = details === null || details === void 0 ? void 0 : details.rejectedEventIds;
            }
        },
        readyForBasketReset() { },
        /**
         * @deprecated Use resetStateWithSavedFields or resetStateByFields
         */
        resetState(state, action) {
            var _a;
            if ((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.saveUnSubmittedOutcomes) {
                const basketOutcomesList = (0, _reduxjs_1.getValues)(state.basket.entry.outcomesMap.sortedIds, (0, utils_1.basketOutcomesMapToId)(state.basket.entry.outcomesMap.entries)).filter((el) => !state.ordinar.outcomesAmounts[el.id]);
                // todo handle in web-mobile, too
                return {
                    ...exports.initialState,
                    layout: {
                        ...exports.initialState.layout,
                        coefficientStatusOnChanged: state.layout.coefficientStatusOnChanged,
                    },
                    basket: {
                        ...exports.initialState.basket,
                        entry: {
                            ...exports.initialState.basket.entry,
                            outcomesMap: {
                                entries: (0, utils_1.basketOutcomesListToMap)(basketOutcomesList),
                                sortedIds: (0, map_1.default)(basketOutcomesList, 'id'),
                            },
                        },
                    },
                };
            }
            else {
                return {
                    ...exports.initialState,
                    layout: {
                        ...exports.initialState.layout,
                        coefficientStatusOnChanged: state.layout.coefficientStatusOnChanged,
                    },
                };
            }
        },
        resetStateWithSavedFields(state, action) {
            var _a;
            const fieldsToSave = ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.fields) || [];
            const savedValues = {};
            fieldsToSave.forEach((fieldKey) => {
                savedValues[fieldKey] = (0, get_1.default)(state, fieldKey);
            });
            const newState = (0, cloneDeep_1.default)(exports.initialState);
            fieldsToSave.forEach((fieldKey) => {
                if (savedValues[fieldKey]) {
                    (0, set_1.default)(newState, fieldKey, savedValues[fieldKey]);
                }
            });
            return newState;
        },
        resetStateByFields(state, action) {
            var _a;
            const fieldsToReset = ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.fields) || [];
            fieldsToReset.forEach((fieldKey) => {
                (0, set_1.default)(state, fieldKey, (0, get_1.default)(exports.initialState, fieldKey));
            });
        },
        stopMakingBet(state) {
            state.makeBetRequest.loading = false;
        },
        setShowMakeBasketSuccessMessage(state, action) {
            state.layout.isShowMakeBasketSuccessMessage = action.payload;
        },
        setBonusWallet(state, action) {
            state.layout.bonusWallet = action.payload;
        },
        activateBonusWallet(state) {
            state.layout.bonusWallet = true;
        },
        resetBonusWallet(state) {
            state.layout.bonusWallet = false;
        },
        addOutcomeToBasket(state, _action) {
            state.addToBasketRequest.loading = true;
            state.addToBasketRequest.error = null;
        },
        addLoadingOutcomeKey: (state, { payload: outcomeKey }) => {
            state.loadingOutcomeKeys[outcomeKey] = true;
        },
        clearLoadingOutcomeKey: (state, { payload: outcomeKey }) => {
            delete state.loadingOutcomeKeys[outcomeKey];
        },
        resetBasketErrors(state) {
            state.errors = [];
        },
        resetBasketClientErrors(state) {
            state.clientErrors = [];
        },
        removeBasketErrors(state, { payload: { errors } }) {
            state.errors = state.errors.filter((error) => !errors.includes(error));
        },
        removeBasketClientErrors(state, { payload: { errors } }) {
            state.clientErrors = state.clientErrors.filter((error) => !errors.includes(error));
        },
        setBasketErrors(state, { payload: { errors } }) {
            state.errors = (0, uniq_1.default)([...state.errors, ...errors]);
            state.makeBetRequest.loading = false;
        },
        setBasketClientErrors(state, { payload: { errors } }) {
            state.clientErrors = (0, uniq_1.default)([...state.errors, ...errors]);
            state.makeBetRequest.loading = false;
        },
        setOrdinarOutcomeErrors(state, { payload }) {
            state.ordinar.outcomeErrors = payload;
        },
        setOrdinarErrorMessage(state, { payload }) {
            state.ordinar.errorMessages = payload;
        },
        updateBasketOutcomes(state, _action) {
            state.addToBasketRequest.loading = true;
            state.addToBasketRequest.error = null;
        },
        updateBasketOutcomesSuccess(state, { payload: { basket } }) {
            for (const outcome of basket.outcomes) {
                const { id, maxBet } = outcome;
                if (state.ordinar.outcomesAmounts[id] === undefined) {
                    if (state.ordinar.singleAmountActive) {
                        state.ordinar.outcomesAmounts[id] = state.ordinar.singleAmount;
                        state.ordinar.outcomeErrors[id] = {
                            id,
                            amount: state.ordinar.singleAmount,
                            maxBet,
                        };
                    }
                    else {
                        state.ordinar.outcomesAmounts[id] = '';
                    }
                }
            }
            (0, state_1.mutationComputeBasketOutcomesMap)({
                outcomesList: basket.outcomes,
                outcomesMap: state.basket.entry.outcomesMap.entries,
            });
            state.basket.entry.outcomesMap.sortedIds = (0, map_1.default)(basket.outcomes, 'id');
            state.basket.entry.dependentEventGroups = basket.dependentEventGroups;
            state.basket.constraints = basket.constraints;
            state.basket.appliedCouponIds = basket.appliedCouponIds;
            const outcomesCount = (0, utils_1.getBasketOutcomesNumber)(state.basket.entry.outcomesMap.entries);
            const isTypeOrdinar = state.layout.betTypeTab === types_1.EBetTypes.Ordinar;
            if (outcomesCount > 1 &&
                isTypeOrdinar &&
                !state.ordinar.singleAmountActive) {
                state.layout.betTypeTab = types_1.EBetTypes.Express;
            }
            state.addToBasketRequest.loading = false;
            state.addToBasketRequest.error = null;
        },
        updateBasketOutcomesError(state, action) {
            state.addToBasketRequest.loading = false;
            state.addToBasketRequest.error = action.payload;
        },
        deleteBasket(state) {
            state.deleteBasketRequest.loading = true;
            state.deleteBasketRequest.error = null;
        },
        deleteBasketSuccess(state) {
            return {
                ...exports.initialState,
                layout: {
                    ...exports.initialState.layout,
                    coefficientStatusOnChanged: state.layout.coefficientStatusOnChanged,
                },
            };
        },
        deleteBasketOutcome(state, _action) {
            state.deleteBasketOutcomeRequest.loading = true;
            state.deleteBasketOutcomeRequest.error = null;
        },
        deleteBasketOutcomeSuccess(state, { payload: { outcomeId }, }) {
            state.deleteBasketOutcomeRequest.loading = false;
            state.deleteBasketOutcomeRequest.error = null;
            (0, state_1.mutationClearDeletedOrdinarsInfo)(state.ordinar, [outcomeId]);
            (0, state_1.mutationRemoveBasketOutcomeById)({
                outcomeId,
                outcomesMap: state.basket.entry.outcomesMap.entries,
            });
            state.basket.entry.outcomesMap.sortedIds =
                state.basket.entry.outcomesMap.sortedIds.filter((basketOutcomeId) => basketOutcomeId !== outcomeId);
            state.basket.appliedCouponIds = [];
            const basketOutcomesNumber = (0, utils_1.getBasketOutcomesNumber)(state.basket.entry.outcomesMap.entries);
            if (basketOutcomesNumber === 1) {
                state.layout.betTypeTab = types_1.EBetTypes.Ordinar;
            }
            else if (basketOutcomesNumber <= 2 &&
                !state.ordinar.singleAmountActive) {
                state.layout.betTypeTab = types_1.EBetTypes.Express;
            }
        },
        deleteBasketOutcomeError(state, action) {
            state.deleteBasketOutcomeRequest.loading = false;
            state.deleteBasketOutcomeRequest.error = action.payload;
        },
        getBasket(state) {
            state.getBasketsRequest.loading = true;
            state.getBasketsRequest.error = null;
        },
        getBasketSuccess(state, { payload: { outcomes, dependentEventGroups, constraints, appliedCouponIds, }, }) {
            // Must be here before all mutations
            const prevOutcomeIds = state.basket.entry.outcomesMap.sortedIds;
            const receivedOutcomeIds = outcomes.map((i) => i.id);
            const deletedIds = (0, difference_1.default)(prevOutcomeIds, receivedOutcomeIds);
            const newIds = (0, difference_1.default)(receivedOutcomeIds, prevOutcomeIds);
            state.getBasketsRequest.loading = false;
            (0, state_1.mutationComputeBasketOutcomesMap)({
                outcomesList: outcomes,
                outcomesMap: state.basket.entry.outcomesMap.entries,
            });
            state.basket.entry.outcomesMap.sortedIds = (0, map_1.default)(outcomes, 'id');
            state.basket.entry.dependentEventGroups = dependentEventGroups;
            state.basket.constraints = constraints;
            state.basket.appliedCouponIds = appliedCouponIds;
            /* We can skip ordinar mutation when we didnt get any updates */
            const outcomeIdsChanged = deletedIds.length > 0 || newIds.length > 0;
            if (outcomeIdsChanged) {
                (0, state_1.mutationChangeOrdinars)(state.ordinar, newIds, deletedIds);
            }
        },
        getBasketError(state, action) {
            state.getBasketsRequest.loading = false;
            state.getBasketsRequest.error = action.payload;
        },
        highlightDependentOutcomes(state, { payload: { eventId } }) {
            const dependentOutcomesList = state.basket.entry.dependentEventGroups
                .filter((outcomesList) => outcomesList.includes(eventId))
                .flat();
            state.layout.highlightedDependentOutcomesList = dependentOutcomesList;
        },
        doNotHighlightDependentOutcomes(state) {
            state.layout.highlightedDependentOutcomesList = [];
        },
        setAppliedCoupon(state, { payload }) {
            state.basket.currentAppliedCoupon = payload;
        },
        setAppliedCouponAmount(state, { payload }) {
            if ((0, utils_1.getBasketOutcomesNumber)(state.basket.entry.outcomesMap.entries) === 1) {
                state.ordinar.outcomesAmounts = (0, mapValues_1.default)((0, utils_1.basketOutcomesMapToId)(state.basket.entry.outcomesMap.entries), () => payload);
            }
            state.express.amount = payload;
            state.system.amount = payload;
        },
        filterRejectedIds(state) {
            const outcomes = Object.values(state.basket.entry.outcomesMap.entries);
            const rejectedIds = state.competitorConstraints.rejectedEventIds;
            state.competitorConstraints.rejectedEventIds = rejectedIds.filter((id) => outcomes.some(({ event }) => event.id === id));
        },
    },
});
exports.basketProviderActions = basketStateSlice.actions, exports.reducer = basketStateSlice.reducer, exports.sliceKey = basketStateSlice.name;
//# sourceMappingURL=slice.js.map